import BASE from "./es.json";
export const ES = {
  ...BASE,
};
